import React from 'react'
import { Typography } from '@material-ui/core'
import validacaoFacialRepository from './ValidacaoFacialRepository'
import RequisicaoCard from '../RequisicaoCard'
import { formatToPercentage } from '../../../../utils/Utils'

export const BiometriaFaceProbabilidade = {
  altissimaProbabilidade: 'Altíssima probabilidade',
  altaProbabilidade: 'Alta probabilidade',
  baixaProbabilidade: 'Baixa probabilidade',
  baixissimaProbabilidade: 'Baixíssima probabilidade'
}

const ValidacaoFacialCard = ({ match, cpf, disabled, validateFieldName }) => {
  const transform = query => ({
    ...query,
    cpf
  })

  const validateData = data => {
    if (
      data &&
      (data.biometriaFaceProbabilidade ===
        BiometriaFaceProbabilidade.altissimaProbabilidade ||
        data.biometriaFaceProbabilidade ===
          BiometriaFaceProbabilidade.altaProbabilidade)
    ) {
      return {
        status: 'SUCCESS',
        message: ''
      }
    }
    return {
      status: 'ERROR',
      message: 'Probabilidade da Biometria da Face não é alta o suficiente'
    }
  }

  return (
    <RequisicaoCard
      title="Validação Facial"
      match={match}
      repository={validacaoFacialRepository}
      transformManualFetch={transform}
      transformQuery={transform}
      disabled={disabled}
      validData={true}
      validateData={validateData}
      validateFieldName={validateFieldName}
      queryToFindRequisicao={{
        cpf
      }}
    >
      {data => (
        <>
          {data.biometriaFaceProbabilidade && (
            <Typography>
              <b>Probabilidade da Biometria da Face:</b>{' '}
              {data.biometriaFaceProbabilidade}
            </Typography>
          )}
          {data.biometriaFaceSimilaridade && (
            <Typography>
              <b>Similaridade da Biometria da Face:</b>{' '}
              {formatToPercentage(data.biometriaFaceSimilaridade)}
            </Typography>
          )}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(ValidacaoFacialCard)
